module.exports = __webpack_public_path__ + "static/img/TCL QD-Mini LED电视X11H.afb01118.png";